import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-sweden',
    templateUrl: './sweden.component.html',
    styleUrls: ['./sweden.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SwedenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
